<app-account-cancellation [isVisible]="showDeactivateAccountModal" (modalClosed)="handleDeactivateAccountClose()"></app-account-cancellation>

<section class="p-6">

  <!-- Account Tabs -->
  <app-account-tabs></app-account-tabs>

  <div>
    <dl class="md:space-y-12">

      <div class="grid md:grid-cols-3 gap-4 md:gap-4 xl:gap-8 sm:px-0">

        <!-- User -->
        <div class="relative flex justify-center items-center p-4 col-span-1 sm:mt-0 rounded-xl bg-gray-50 h-32">

          <button type="button" routerLink="/settings/profile" class="absolute top-2 right-2 text-blue-royal hover:opacity-90 transition-transform duration-300 hover:-rotate-6" matTooltip="Edit" matTooltipPosition="left" matTooltipClass="blue-royal-tooltip">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
              <path d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z" />
            </svg>
          </button>

          <div class="flex items-center">
            <div>
              <img class="inline-block h-12 w-12 rounded-full" [src]="user.profile_photo || 'https://ui-avatars.com/api/?name=' + user.name + '&background=d1d5dc&color=fff'" (error)="onImageError($event)" alt="avatar">
            </div>
            <div class="ml-3">
              <p class="font-semibold text-secondary dark:text-secondary">{{ user.name }}</p>
              <p class="text-sm font-medium text-secondary/75 dark:text-secondary">{{ user.email }}</p>
            </div>
          </div>

        </div>

        <!-- Credits -->
        <div class="relative flex justify-center items-center p-4 col-span-1 sm:mt-0 rounded-xl bg-gray-50 h-32">

          <button type="button" (click)="openBillingPortal()" class="absolute top-2 right-2 text-blue-royal hover:opacity-90 transition-transform duration-300 hover:-rotate-6" matTooltip="Manage Subscription" matTooltipPosition="left" matTooltipClass="blue-royal-tooltip">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5" matTooltip="Manage Subscription" matTooltipPosition="left" matTooltipClass="blue-royal-tooltip">
              <path fill-rule="evenodd" d="M2.5 4A1.5 1.5 0 0 0 1 5.5V6h18v-.5A1.5 1.5 0 0 0 17.5 4h-15ZM19 8.5H1v6A1.5 1.5 0 0 0 2.5 16h15a1.5 1.5 0 0 0 1.5-1.5v-6ZM3 13.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4.75-.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z" clip-rule="evenodd" />
            </svg>
          </button>

          <div class="flex justify-center items-end">
            <span class="text-xl font-bold text-secondary pr-1">{{ credits$ | async }}</span>
            <span class="text-md font-bold text-secondary">Credits</span>
          </div>
        </div>

        <!-- Public Profile -->
        <div [ngClass]="!user.linkedin_url ? 'hidden' : '' " class="relative flex items-center bg-blue-royal p-4 col-span-1 sm:mt-0 rounded-lg h-32">

          <button type="button" (click)="copyProfileUrl()" class="absolute top-2 right-2 text-white/90 hover:opacity-90 transition-transform duration-300 hover:-rotate-6" matTooltip="Copy" matTooltipPosition="left" matTooltipClass="blue-royal-tooltip">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
              <path fill-rule="evenodd" d="M13.887 3.182c.396.037.79.08 1.183.128C16.194 3.45 17 4.414 17 5.517V16.75A2.25 2.25 0 0 1 14.75 19h-9.5A2.25 2.25 0 0 1 3 16.75V5.517c0-1.103.806-2.068 1.93-2.207.393-.048.787-.09 1.183-.128A3.001 3.001 0 0 1 9 1h2c1.373 0 2.531.923 2.887 2.182ZM7.5 4A1.5 1.5 0 0 1 9 2.5h2A1.5 1.5 0 0 1 12.5 4v.5h-5V4Z" clip-rule="evenodd" />
            </svg>
          </button>

          <div class="flex flex-col text-left">
            <span class="font-bold text-white">Public Profile</span>
            <a [routerLink]="['/' + this.user.public_profile_url]" class="cursor-pointer underline text-sm text-white/90 hover:opacity-90">{{ window.location.origin + '/' + this.user.public_profile_url }} </a>
          </div>
        </div>

      </div>

      <button (click)="resetAndStartTour()" class="hidden lg:block btn btn-blue mt-0">
        Start Tour Again
      </button>

      <!--
      <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-secondary-900 dark:text-primary-100">Email</dt>
        <dd class="mt-1 text-sm leading-6 text-secondary-900 dark:text-primary-200 sm:col-span-2 sm:mt-0">{{ user.email }}</dd>
      </div>

      <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-secondary-900 dark:text-primary-100">Password</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
          <a href="" routerLink="/settings/profile" class="underline w-full justify-center text-sm font-semibold leading-6 text-secondary-900 dark:text-primary-200">Change password</a>
        </dd>
      </div>
      -->

      <div *ngIf="user.subscribed && user.plan" class="px-4 py-6 pt-0 sm:grid sm:grid-cols-1 sm:gap-4 sm:px-0">
        <div class="bg-white dark:bg-indigo-custom">
          <div class="mx-auto w-full">
            <div class="mx-auto mt-5 rounded-md lg:flex lg:max-w-none">
              <div class="lg:flex-auto">
                <h2 class="text-lg font-semibold tracking-tight text-secondary-900 dark:text-primary-100">Your subscription: {{ user.plan ? user.plan.name : '-' }}, paid {{ user.plan ? user.plan.interval : '-' }}</h2>
                <p class="text-sm leading-6 text-gray-500 dark:text-primary-200">{{ user.plan.short_description }}</p>

                <div *ngIf="user.current_billing_cycle_count" class="mt-2 text-base leading-7 text-gray-500">
                  <div class="h-1 w-full bg-gray-100 mb-2">
                    <div class="h-1 bg-orange-400" style="width: {{(user.current_billing_cycle_count/user.plan.options['reports'])*100}}%"></div>
                  </div>
                  <div >
                    <p class="text-secondary-900 dark:text-primary-200">Current month's usage: <span class="font-bold text-secondary-900 dark:text-primary-200">{{ user.current_billing_cycle_count }}</span>/{{ user.plan.options['reports'] }}</p>
                    <p class="text-secondary-900 dark:text-primary-200">Next refill date: <span class="font-bold text-secondary-900 dark:text-primary-200">{{ user.current_billing_cycle[1] }}</span></p>
                  </div>
                </div>

                <div class="mt-10 flex items-center gap-x-4">
                  <h4 class="flex-none text-sm font-semibold leading-6 text-secondary-900 dark:text-primary-100">What’s included</h4>
                  <div class="h-px flex-auto bg-gray-200 dark:bg-[#3b4377]"></div>
                </div>

                <ul role="list" class="mt-6 grid grid-cols-1 gap-4 text-sm leading-6 text-gray-500 sm:grid-cols-2 sm:gap-6">
                  <li class="flex gap-x-3" *ngFor="let feature of user.plan.features">
                    <svg class="h-6 w-5 flex-none text-indigo-600" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                    </svg>
                    <span class="text-gray-600 dark:text-primary-200">{{ feature }}</span>
                  </li>
                </ul>

                <p class="mt-6 text-xs leading-5 text-gray-600 dark:text-primary-200">Invoices and receipts available for easy company reimbursement. View billing section for downloads.</p>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-6 mb-6">
        <h2 class="text-lg font-bold tracking-tight text-secondary-900 dark:text-primary-100 mb-3">Integrations</h2>

        <ul role="list" class="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8">
          <li class="overflow-hidden rounded-xl border border-gray-100 dark:border-[#3b4377]">
            <div class="flex items-center gap-x-4 border-b border-gray-100 dark:border-[#3b4377] bg-white  dark:bg-[#252c5f] p-6">
              <img src="https://logowik.com/content/uploads/images/gmail-new-icon5198.jpg" alt="Tuple" class="h-12 w-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10">
              <div class="text-sm font-medium leading-6 text-secondary-900 dark:text-primary-100">Gmail Account</div>
            </div>
            <dl class="-my-3 divide-y divide-gray-100 dark:divide-[#3b4377] px-6 py-4 text-sm leading-6">
              <div class="flex justify-between gap-x-4 py-3">
                <dt class="text-gray-500 dark:text-primary-200">Status</dt>
                <dd class="text-secondary-900 dark:text-primary-200" *ngIf="isConnectedToGoogle"><div class="rounded-md py-1 px-2 text-xs font-medium text-green-500 bg-green-50">Connected</div></dd>

                <dd class="text-secondary-900 dark:text-primary-200" *ngIf="!isConnectedToGoogle"><div class="rounded-md py-1 px-2 text-xs font-medium text-red-500 bg-red-50">Not connected</div></dd>
              </div>
              <div class="flex justify-between gap-x-4 py-3">
                <dt class="text-gray-500 dark:text-primary-200">Actions</dt>
                <dd class="flex items-start gap-x-2"*ngIf="!isConnectedToGoogle">

                  <div>
                    <!-- (click)="testJobHubspot()"-->
                    <button  (click)="authorizeGoogle()" type="button" class="btn btn-secondary">Connect</button>

                  </div>
                </dd>
                <dd class="flex items-start gap-x-2"*ngIf="isConnectedToGoogle">
                  <div>
                    <button (click)="disconnectGoogle()"  type="button" class="btn btn-danger">Disconnect</button>
                    <!-- <button (click)="authorizeGoogle2()"   type="button" class="rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Connect</button>-->
                  </div>
                </dd>
              </div>
            </dl>
          </li>
          <li class="overflow-hidden rounded-xl border border-gray-100 dark:border-[#3b4377]">
            <div class="flex items-center gap-x-4 border-b border-gray-100 dark:border-[#3b4377] bg-white  dark:bg-[#252c5f] p-6">
              <img src="https://logowik.com/content/uploads/images/hubspot5453.logowik.com.webp" alt="Tuple" class="h-12 w-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10">
              <div class="text-sm font-medium leading-6 text-secondary-900 dark:text-primary-100">HubSpot</div>
            </div>
            <dl class="-my-3 divide-y divide-gray-100 dark:divide-[#3b4377] px-6 py-4 text-sm leading-6">
              <div class="flex justify-between gap-x-4 py-3">
                <dt class="text-gray-500 dark:text-primary-200">Status</dt>
                <dd class="text-secondary-900 dark:text-primary-200" *ngIf="isConnectedToHubSpot"><div class="rounded-md py-1 px-2 text-xs font-medium text-green-500 bg-green-50">Connected  </div></dd>

                <dd class="text-secondary-900 dark:text-primary-200" *ngIf="!isConnectedToHubSpot"><div class="rounded-md py-1 px-2 text-xs font-medium text-red-500 bg-red-50">Not connected </div></dd>
              </div>
              <div class="flex justify-between gap-x-4 py-3">
                <dt class="text-gray-500 dark:text-primary-200">Actions</dt>
                <dd class="flex items-start gap-x-2"*ngIf="!isConnectedToHubSpot">
                    <button (click)="authorizeHubspot()" type="button" class="btn btn-secondary">Connect</button>
                </dd>
                <dd class="flex items-start gap-x-2"*ngIf="isConnectedToHubSpot">
                  <button (click)="disconnectHubspot()" type="button" class="btn btn-danger">Disconnect</button>
                </dd>
              </div>
            </dl>
          </li>

          <!-- Livespace -->
          <li class="overflow-hidden rounded-xl border border-gray-100 dark:border-[#3b4377]">
            <div class="flex items-center gap-x-4 border-b border-gray-100 dark:border-[#3b4377] bg-white dark:bg-[#252c5f] p-6">
              <img src="assets/images/livespace.png" alt="Livespace" class="h-12 w-12 flex-none rounded-lg ring-1 ring-gray-900/10 object-contain"/>
              <div class="text-sm font-medium leading-6 text-secondary-900 dark:text-primary-100">Livespace</div>
            </div>
            <dl class="-my-3 divide-y divide-gray-100 dark:divide-[#3b4377] px-6 py-4 text-sm leading-6">
              <div class="flex justify-between gap-x-4 py-3">
                <dt class="text-gray-500 dark:text-primary-200">Status</dt>
                <dd class="text-secondary-900 dark:text-primary-200" *ngIf="isConnectedToLivespace">
                  <div class="rounded-md py-1 px-2 text-xs font-medium text-green-500 bg-green-50">Connected</div>
                </dd>
                <dd class="text-secondary-900 dark:text-primary-200" *ngIf="!isConnectedToLivespace">
                  <div class="rounded-md py-1 px-2 text-xs font-medium text-red-500 bg-red-50">Not connected</div>
                </dd>
              </div>
              <div class="flex justify-between gap-x-4 py-3">
                <dt class="text-gray-500 dark:text-primary-200">Actions</dt>
                <dd class="flex items-start gap-x-2" *ngIf="!isConnectedToLivespace">
                  <button (click)="openLivespaceConnect()" type="button" class="btn btn-secondary">Connect</button>
                </dd>
                <dd class="flex items-start gap-x-2" *ngIf="isConnectedToLivespace">
                  <button (click)="disconnectLivespace()" type="button" class="btn btn-danger">Disconnect</button>
                </dd>
              </div>
            </dl>
          </li>
        </ul>

      </div>

      <!-- Livespace Connect Dialog -->
      <app-livespace-connect-dialog
        *ngIf="showLivespaceConnectDialog"
        (closed)="closeLivespaceConnect()"
        (connected)="onLivespaceConnected()">
      </app-livespace-connect-dialog>

      <div class="pt-6 flex justify-start items-center">

        <button type="button" (click)="deactivateAccount()" class="btn btn-danger">
          Close account
        </button>

      </div>

    </dl>
  </div>

  <div [ngClass]="!this.state.isLoading ? 'hidden' : ''  " class="flex flex-col items-center justify-center min-h-screen">

    <span class="loader"></span>
    <h1 class="ml-4 mt-3  text-3xl font-extrabold leading-none tracking-tight  text-surface md:text-3xl lg:text-3xl ">Loading</h1>
    <!--  <p class="text-mg mt-3 m-4 text-center text-surface">Come back to this page later or wait for the report to finish. The page will-->
    <!--    <span class=" font-extrabold text-primary">automatically</span> display the information once the research has been finished.</p>-->
  </div>

</section>
